<div class="recent-searches" *transloco="let t">
	<div class="recent-header">
		<span class="recent-title">{{ t(terms().length > 0 ? titleKey() : emptyTitleKey()) }}</span>

		@if (terms().length > 0) {
			<button type="button" class="recent-clear-all" (mousedown)="handleClearAll($event)">
				{{ t('actions.clearAll') }}
			</button>
		}
	</div>

	<div class="recent-chips">
		@for (term of terms(); track term) {
			<span class="recent-chip">
				<button type="button" class="recent-chip-term" (mousedown)="handleSelect($event, term)">
					{{ term }}
				</button>

				<button
					type="button"
					class="recent-chip-remove"
					[attr.aria-label]="t('actions.remove')"
					(mousedown)="handleRemove($event, term)"
				>
					<base-icon [icon]="RemoveIcon" />
				</button>
			</span>
		}
	</div>
</div>
